// extracted by mini-css-extract-plugin
export default {"container":"AdminProfilePage_container__GV-N4","menu":"AdminProfilePage_menu__N5USc","menuLink":"AdminProfilePage_menuLink__h6Eje","content":"AdminProfilePage_content__0kjN5"};